import type { EduSchool } from '@common/types/edu-course.type';

import { createActionGroup, emptyProps, props } from '@ngrx/store';

const EduSchoolsActions = createActionGroup({
    source: 'EduSchools/Collection/API',
    events: {
        'Load Collection Request': emptyProps(),
        'Load Collection Success': props<{ schools: EduSchool[] }>(),
        'Load Collection Failure': props<{ error: string }>(),
    },
});

export default EduSchoolsActions;
